import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnInit, PLATFORM_ID, ViewChild, ViewEncapsulation } from '@angular/core';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import { NgbCarousel, NgbSlideEvent, NgbSlideEventSource } from '@ng-bootstrap/ng-bootstrap';
import { SummaryInfo } from 'src/app/core/models/summary-info';
import { SummaryHomeService } from 'src/app/core/services/summary-home.service';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
import { SummaryIpo } from 'src/app/core/models/summary-ipo';
import { Page } from 'src/app/core/models/page';
import { SortData } from 'src/app/core/models/sort-data';
import { SummaryHeadline } from 'src/app/core/models/summary-headline';
import { SummaryCapitalIncrease } from 'src/app/core/models/summary-capital-increase';
import { SummaryStockRecommendation } from 'src/app/core/models/summary-stock-recommendation';
import { Dividend } from 'src/app/core/models/dividend';
import { DividendService } from 'src/app/core/services/dividend.service';
import { SummaryDividendYear } from 'src/app/core/models/summary-dividend-year';
import { Utils } from 'src/app/core/utils/utils';
import { SummaryDividendAnalysis } from 'src/app/core/models/summary-dividend-analysis';
import { SummaryAnalysis } from 'src/app/core/models/summary-analysis';
import { AnalysisType } from 'src/app/core/enums/analysis-type';
import { IpoType } from 'src/app/core/enums/ipo-type';
import { DateUtil } from 'src/app/core/utils/date-util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  encapsulation:ViewEncapsulation.None,
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  domainURL=environment.domain+"/"+(this.localId+"").substring(0,2)+"/";
	paused = false;
	unpauseOnArrow = false;
	pauseOnIndicator = false;
	pauseOnHover = true;
	pauseOnFocus = true;
	infoList:SummaryInfo[];
	headlineList:SummaryHeadline[];
	carouselList:SummaryHeadline[];
	sidebarList:SummaryHeadline[];
	capitalIncreaseList:SummaryCapitalIncrease[];
	recommendationList:SummaryStockRecommendation[];
	ipoDraftList:SummaryIpo[];
	ipoRealList:SummaryIpo[];
	dividendList:Dividend[];
	dividendIncreaseList:SummaryDividendYear[];
	dividendAnalysisList:SummaryDividendAnalysis[];
	analysisList:SummaryAnalysis[];
	greatestDividendList:Dividend[];
	date : Date;
  month: any;
  monthStrings: any;
  year = (new Date()).getFullYear();
	page = new Page();
	pageInfo = new Page();
	sorts=new Array();
	faElipsis=faEllipsis;
	lang='tr';
	isBrowser:any;
	destroy$: Subject<boolean> =new Subject<boolean>();
  years: number[] = [];
	currentYear = new Date().getFullYear();

	@ViewChild('carousel', { static: true }) carousel: NgbCarousel;

	togglePaused() {
		if (this.paused) {
			this.carousel.cycle();
		} else {
			this.carousel.pause();
		}
		this.paused = !this.paused;
	}

	onSlide(slideEvent: NgbSlideEvent) {
		if (
			this.unpauseOnArrow &&
			slideEvent.paused &&
			(slideEvent.source === NgbSlideEventSource.ARROW_LEFT || slideEvent.source === NgbSlideEventSource.ARROW_RIGHT)
		) {
			this.togglePaused();
		}
		if (this.pauseOnIndicator && !slideEvent.paused && slideEvent.source === NgbSlideEventSource.INDICATOR) {
			this.togglePaused();
		}
	}

  constructor(
	@Inject(LOCALE_ID) private localId: Object,
    @Inject(PLATFORM_ID) private platformId: Object,
    public summaryService: SummaryHomeService,
    public dividendService: DividendService

  ) { }

  ngOnDestroy(): void{
	this.destroy$.next(true);
	this.destroy$.unsubscribe();
}

  ngOnInit(): void {
	this.isBrowser=isPlatformBrowser(this.platformId)
    if (this.isBrowser||isPlatformServer(this.platformId)) {
    for (let year = this.currentYear; year > this.currentYear - 3; year--) {
        this.years.push(year);
    }
		this.getHeadlineList();
    this.getRecommendationList();
    this.getCapitalIncreaseList();
		this.getInfoList();
		this.getIpoList();
		this.getDividendAnalysisList();
		this.getAnalysisList();
		this.getDividendYear(this.currentYear);
		this.pageInfo = new Page();
		this.pageInfo.pageNumber = 1;
		this.pageInfo.size = 5;
		this.sorts=[{"dir": "desc", "prop": "cashDvdndDt"}]
		this.setPage(this.pageInfo);
    const d = new Date()
    this.monthStrings = Utils.getMKeys(Utils.monthStrings);
    this.month=this.monthStrings[d.getMonth()]
    }
  }

  getMostGreatestDividendsList(year) {
    this.summaryService.getMostIncreaseDividendStocks(this.lang,year).subscribe(dividends => {
      this.dividendIncreaseList = dividends
  })

  }
  getDividendYear(year) {
    this.getMostGreatestDividendsList(year);
  }

  getInfoList(){
	this.summaryService.getInfoListByLang(this.lang) .subscribe(infos => {
        this.infoList= infos
    })
  }

  getDividendAnalysisList(){
    this.summaryService.getAnalysisListByLang(this.lang,AnalysisType[AnalysisType.DIVIDEND]) .subscribe(dividendAnalysises => {
          this.dividendAnalysisList= dividendAnalysises

      })
    }

  getAnalysisList(){
	this.summaryService.getAnalysisListByLang(this.lang,AnalysisType[AnalysisType.STOCK]) .subscribe(analysises => {
        this.analysisList= analysises
    })
  }

  getHeadlineList(){
	this.summaryService.getHeadlineListByLang(this.lang) .subscribe(headlines => {
        this.carouselList = headlines.slice(0, 6)
        this.sidebarList = headlines.slice(-4);
    })
  }
  getRecommendationList(){
	this.summaryService.getStockRecommendations(this.lang) .subscribe(recommendations => {
        this.recommendationList=recommendations
    })
  }

  getCapitalIncreaseList(){
	this.summaryService.getCapitalIncreases(this.lang) .subscribe(capitalIncreases => {
        this.capitalIncreaseList=capitalIncreases
    })
  }

  getIpoList(){
	this.summaryService.getIpoListByType(this.lang,IpoType[IpoType.DRAFT]).subscribe(ipos => {
        this.ipoDraftList= ipos
    })
	this.summaryService.getIpoListByType(this.lang,IpoType[IpoType.REAL]).subscribe(ipos => {
        this.ipoRealList= ipos
    })

  }

  setPage(pageInfo) {
    this.pageInfo = pageInfo;
    let sortData=new SortData<Dividend>();
    let dividend = new Dividend();
    dividend.lang="tr";
    dividend.country="tr";
    dividend.startDate=DateUtil.getFirstDayOfMonth();
    dividend.endDate=DateUtil.getLastDayOfMonth();
    sortData.sorts=this.sorts;
    sortData.filter=dividend;
    this.pageInfo.pageNumber = this.pageInfo.pageNumber - 1;
    this.dividendService.getPageAbleList(this.pageInfo,sortData).pipe(takeUntil(this.destroy$)).subscribe(pagedData => {
      this.pageInfo = pagedData.page;
      this.page.pageNumber = this.page.pageNumber-1;
      this.dividendList = pagedData.data;
      this.dividendList.map(p=>DateUtil.isDateBeforeToday(p.cashDvdndDt)?true:false)

    });

  }


  public trackByFnInfo(index, item) {
    if (!item) return null;
    return item.id;
  }
  public trackByFnIpoReal(index, item) {
    if (!item) return null;
    return item.id;
  }
  public trackByFnIpoDraft(index, item) {
    if (!item) return null;
    return item.id;
  }
  public trackByFnDividend(index, item) {
    if (!item) return null;
    return item.id;
  }
  public trackByFnHeadline(index, item) {
    if (!item) return null;
    return item.id;
  }
  public trackByFnSidebar(index, item) {
    if (!item) return null;
    return item.id;
  }
  public trackByFnAnalysis(index, item) {
    if (!item) return null;
    return item.id;
  }
  public trackByFnDividendAnalysis(index, item) {
    if (!item) return null;
    return item.id;
  }
  public trackByFnCarousel(index, item) {
    if (!item) return null;
    return item.id;
  }
  public trackByFnStockRecommendation(index, item) {
    if (!item) return null;
    return item.id;
  }
  public trackByFnCapitalIncrease(index, item) {
    if (!item) return null;
    return item.id;
  }
  public trackByFnDividendIncrease(index, item) {
    if (!item) return null;
    return item.id;
  }

}
